export const GBOX_TIMELINE_NS = "urn:slickshift:gbox-timeline:0"
export const GBOX_TIMELINE_COMMAND_NODE = "get_gbox_timeline_view"

export type GboxTimelineEvent = {
  eventId: string
  errandId: string
  chainId: string
  kind: "pickup" | "delivery" | "other"
  kindLabel: string
  title: string
  subtitle?: string
  // The principal the transport is run for, as opposed to `title`, which is
  // the company of this particular site. Navigator-only — G-Box errands do
  // not carry it, so it stays undefined for those feeds.
  customer?: string
  referenceNumber?: string
  countryCode?: string
  scheduledTime?: string
  // When the stop was really served. Navigator-only — G-Box and Platform
  // Science feeds report completion as a flag without a timestamp, so their
  // events leave it undefined.
  realTime?: string
  estimatedArrivalTime?: string
  estimatedArrivalTimeWithTacho?: string
  timelinessStatus?: string
  delaySeconds?: number
  delayWithTachoSeconds?: number
  sequence?: number
  externalStatus?: string
  errandStatusLabel?: string
  isCurrentErrand: boolean
  isCurrentEvent: boolean
  isCompleted: boolean
  isOnRoute: boolean
}

export type GboxTimelineFeed = {
  entityJid?: string
  chatJid?: string
  driverJid?: string
  deviceId: string
  plateNumber?: string
  generatedAt?: string
  events: GboxTimelineEvent[]
}
